import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { LocationGroupResponse } from '../../../../shared/interfaces/qualification.interface';
import { QUALIFICATION_CODES } from '../../../../shared/constants/qualification-code';
import { EnvironmentConfig } from '../../../../shared/interfaces/environment.interface';
import {
  UploadZipCodeApiResponse,
  DownloadLocationFile,
} from '../../../../shared/interfaces/survey.interface';

@Injectable({
  providedIn: 'root',
})
export class LocationQualificationService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;

  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  uploadLocationsFile(
    countryCode: string,
    surveyId: number,
    file: object,
    qualificationCode: number
  ) {
    let apiPath = `${this._baseUrl}/survey/uploadZipCode/${countryCode}?survey=${surveyId}`;
    if (countryCode === 'CA' && qualificationCode === QUALIFICATION_CODES.FSA) {
      apiPath += '&type=fsa';
    }
    return this._http.post<UploadZipCodeApiResponse>(apiPath, file);
  }

  downloadCurrentLocationFile(filePath: string, correctZips: string[]) {
    return this._http.post<DownloadLocationFile>(
      `${this._baseUrl}/survey/downloadZipFileWithValidInvalidZip`,
      { filePath, correctZips }
    );
  }

  getGroupDetails(surveyId: number, qualificationId: number) {
    return this._http.get<LocationGroupResponse[]>(
      `${this._baseUrl}/buyers/v2/surveys/${surveyId}/location-groups/${qualificationId}`
    );
  }
}
